module.exports = __webpack_public_path__ + "img/gyuszigumi4.b2544d12.jpg";